/** Query Params dto. */
export class QueryParamsDto {
  constructor(data) {
    this.page = data.page;
    this.per_page = data.per_page;
    this.order_by = data.order_by;
    this.sort_order = data.sort_order;
  }
}

export const SORT_DIRECTION_DTO = {
  ASC: 'asc',
  DESC: 'desc',
};
